import React, { Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { View } from 'react-native';

import { Text, Dialog } from 'reactor/components';
import {
  Home, Affiliate, Agency, Dictionary, Experiences, Experience, Stories, Story,
} from 'containers';
import { Consumer, Provider } from 'context';
import styles from './App.style';

const Router = () => (
  <Provider>
    <View style={styles.container}>
      <Switch>
        <Route path="/agency/campaign/:id" component={Agency} />
        <Route path="/agency/:key" component={Agency} />
        <Route path="/agency" component={Agency} />

        <Route path="/affiliate/campaign/:id" component={Affiliate} />
        <Route path="/affiliate/:key" component={Affiliate} />
        <Route path="/affiliate" component={Affiliate} />
        <Route path="/dictionary/:key" component={Dictionary} />
        <Route path="/dictionary" component={Dictionary} />

        <Route path="/experiences" component={Experiences} />
        <Route
          path="/experience/:language/:id"
          render={({ match, ...inherit }) => <Experience {...inherit} {...match.params} />}
        />

        <Route path="/stories" component={Stories} />
        <Route
          path="/story/:id"
          render={({ match, ...inherit }) => <Story {...inherit} id={match.params.id} />}
        />

        <Route exact path="/" component={Home} />
        <Route component={({ match }) => (
          <Text>
            Error: Not found
            {JSON.stringify(match)}
          </Text>
        )}
        />
      </Switch>
      <Consumer>
        { ({ l10n, message, onMessage }) => message && (
          <Fragment>
            <Dialog
              visible={message.text !== undefined}
              title={message.title || l10n.DIALOG_TITLE}
              value={message}
              onClose={() => onMessage()}
            >
              <Text>
                {message.text}
              </Text>
            </Dialog>
          </Fragment>
        )}
      </Consumer>
    </View>
  </Provider>
);

export default Router;
